import React from "react";
import ReusableTable from "../../../../../../global components/Table/Table";
import { TableColumnsType } from "antd";
import NoData from "../../../../../../global components/Table/NoData/NoData";
import { PieChart } from "../../../../../../global components/Icons/PieChart";
import { PaginatedMessagingReportType } from "../../../../../../libs/Utils/Types/Reports";
import dayjs from "dayjs";
import Unauthorised from "../../../../../../global components/Unauthorised";
type ColumnsType = {
  serialNumber: number;
  key: number;
  date: string;
  messageSent: number;
  messageFailed: number;
  totalRecipients: number;
  responseRate: string;
};
type PropType = {
  isLoading: boolean;
  dataSource: PaginatedMessagingReportType["data"];
  unauthorized: boolean | { title: string; message: string };
};
function MessagingReportTable({
  dataSource,
  isLoading,
  unauthorized,
}: PropType) {
  const columns: TableColumnsType<ColumnsType> = [
    {
      title: "S/N",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (serialNumber: number) => <span>{serialNumber}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date: string) => <span>{date}</span>,
    },
    {
      title: "Total recipients",
      dataIndex: "totalRecipients",
      key: "totalRecipients",
      render: (totalRecipients: number) => <span>{totalRecipients}</span>,
    },
    {
      title: "Total message sent",
      dataIndex: "messageSent",
      key: "messageSent",
      render: (messageSent: number) => <span>{messageSent}</span>,
    },
    {
      title: "Total message failed",
      dataIndex: "messageFailed",
      key: "messageFailed",
      render: (messageFailed: number) => <span>{messageFailed}</span>,
    },
    {
      title: "Response rate",
      dataIndex: "responseRate",
      key: "responseRate",
      render: (responseRate: string) => <span>{responseRate}</span>,
    },
  ];

  const data: ColumnsType[] =
    dataSource.map((item, index) => ({
      date: dayjs.utc(item.date).local().format("MMM DD, YYYY"),
      messageFailed: item.failed,
      totalSent: item.delivered,
      key: index,
      messageSent: item.delivered,
      serialNumber: index + 1,
      responseRate: item.responseRate,
      totalRecipients: item.totalRecipients,
    })) ?? [];
  return (
    <ReusableTable
      columns={columns}
      dataSource={data}
      loading={isLoading}
      noDataComponent={
        unauthorized ? (
          typeof unauthorized === "boolean" ? (
            <Unauthorised />
          ) : (
            <Unauthorised error={unauthorized} />
          )
        ) : (
          <NoData
            Message="No messaging report found"
            subMessage=""
            icon={<PieChart height={32} width={32} />}
          />
        )
      }
    />
  );
}

export default MessagingReportTable;
